<template>
<div>
    
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">
		<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
		
		<div class=" col-md-6 col-12 p-0">

        <div class="col-12 row mx-0 px-3 py-2" style="background-image: linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123));color:#ffffff;">
          <h3><strong>{{msglist[$route.params.language][7]}}</strong></h3>
        </div>
      
        <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
            <div class="col-12 px-0 row mx-0">
                <div class="col border-left align-self-center">
                    
                    <div class="px-0 mx-0">{{msglist[$route.params.language][8]}} </div>
                    <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="user.username" type="text" class="col px-0 mx-0 mb-2 align-self-center form-control">
                    
                    <div class="px-0 mx-0">{{msglist[$route.params.language][9]}} </div>
                    <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="user.password" type="text" class="col px-0 mx-0 mb-2 align-self-center form-control">
                    
                    <div class="px-0 mx-0">{{msglist[$route.params.language][10]}} </div>
                    <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="user.confirm" type="text" class="col px-0 mx-0 mb-2 align-self-center form-control">

                    <div class="px-0 mx-0">{{msglist[$route.params.language][11]}} </div>
                    <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="user.device" type="text" class="col px-0 mx-0 mb-2 align-self-center form-control">

                    <div class="px-0 mx-0">{{msglist[$route.params.language][12]}} </div>
                    <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="user.passcode" type="text" class="col px-0 mx-0 mb-2 align-self-center form-control">
                    
                    <div class="px-0 mx-0">{{msglist[$route.params.language][13]}} </div>
                    <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="user.email" type="text" class="col px-0 mx-0 mb-2 align-self-center form-control">

                    <div class="col-12 text-center">
                      <button @click="register()" class="mb-2 btn btn-primary" style="min-width: 100px;">{{msglist[$route.params.language][7]}}</button><!--註冊-->
                      <router-link :to="{ name: 'entry', params: { language: $route.params.language }}">
                          <button class="mb-2 btn btn-primary" style="min-width: 40px;">{{msglist[$route.params.language][14]}}</button><!--登入-->
                      </router-link>
                      <router-link :to="{ name: 'forget', params: { language: $route.params.language }}">
                          <button class="mb-2 btn btn-primary" style="min-width: 40px;">{{msglist[$route.params.language][15]}}</button><!--忘記-->
                      </router-link>
                    </div>
                    <div class="col" v-bind:class="alertObject" style="font-size:1.2rem; font-weight: bold"> {{message}} </div>
                  </div>
             </div>
          </div>    
      </div>
</div>    
  
</template>

<script>
  //import has from 'lodash/has';
  //import Log from 'loglevel';
  let PURL = process.env.SERVER;
  
  const mlist = {
	'en': [
        'serial and passcode does not match',
        'Error',
        'username duplicate, please change username',
        'device owned by other user',
        'Successful creat user:',
        'Confirm password is different to password',
        'Space not allowed in username/password/email',
        'Sign up',
        'Username (characters, no space allowed)',
        'Password (characters, optional, no space allowed)', 
        'Confirm Password', 'Device Serial# (in the back of device, ex. KH1-00-00002)', 
        'Activation Code (in the back of the device, ex. AaBb)',
        'email address, optional (for notification)',
        'Sign in','Forget'],
  'vi': [
        'Số Seri Và Mật Mã Máy Không Khớp',
        'Lỗi',
        'Tên Người Dùng Trùng Lặp, Vui Lòng Thay Đổi Tên Người Dùng',
        'Thiết Bị Thuộc Sỡ Hữu Người Khác',
        'Tạo Người Dùng Thành Công:',
        'Xác Nhận Mật Khẩu Khác Với Mật Khẩu Cũ',
        'Không Được Phép Có Khoảng Trống Trong Tên Người Dùng/Mật Khẩu/Email',
        'Đăng Kí',
        'Tài Khoản (ký tự, không được phép có khoảng trắng)',
        'Mật Khẩu (ký tự, tùy chọn, không được phép có khoảng trắng)', 
        'Xác Nhận Mật Khẩu', 'Device Serial# (in the back of device, ex. KH1-00-00002)', 
        'Mã Kích Hoạt (ở mặt sau của thiết bị), ex. AaBb)',
        'Địa Chỉ Email, Tùy Chọn (để thông báo)',
        'Đăng Nhập','Quên Tài Khoản & Mật Khẩu'],
  'ms': [
        'serial and passcode does not match',
        'Error',
        'username duplicate, please change username',
        'device owned by other user',
        'Successful creat user:',
        'Confirm password is different to password',
        'Space not allowed in username/password/email',
        'Sign up',
        'Username (characters, no space allowed)',
        'Password (characters, optional, no space allowed)', 
        'Confirm Password', 'Device Serial# (in the back of device, ex. KH1-00-00002)', 
        'Activation Code (in the back of the device, ex. AaBb)',
        'email address, optional (for notification)',
        'Sign in','Forget'],
	'tw': [
        '啟動碼錯誤',
        '錯誤',
        '已有此會員帳號，請改其他名稱',
        '產品序號已被註冊過，不可重複註冊',
        '成功註冊會員:',
        '確認密碼與密碼不相同',
        '帳號/密碼/電郵不可有空格字',
        '註冊', 
        '會員帳號 (英數，不可有空格)',
        '密碼 (英數，非必須，不可有空格)',
        '再次輸入密碼','產品序號 (在背面，例如 KH1-00-00002)',
        '啟動碼 (在背面，注意大小寫，例如 AaBb)',
        '電子郵件, 非必須 (異常通知)',
        '登入','忘記'],
	'cn': [
        '启动码错误',
        '错误',
        '已有此会员帐号，请改其他名称',
        '产品序号已被登记过，不可重複注册',
        '成功注册会员:',
        '确认密码与密码不相同',
        '帐号/密码/电邮不可有空格字',
        '注册', 
        '用户名 (英数，不可有空格)',
        '密码 (英数，非必须，不可有空格)',
        '再次输入密码',
        '产品序号 (在背面，例如 KH1-00-00002)',
        '啟動碼 (在背面，注意大小寫，例如 AaBb)',
        '电子邮件, 非必须 (异常通知)',
        '登录','忘记']
}

  export default {
    name: "register",
    data: function() {
      return {
        message: "",
        msglist: mlist,
        user: {
          email: "",
          username: "",
          password: "",
          confirm: "",
          device:"",
          passcode:"",
          uitimezone: -12
        }
      }
    },
    computed: {
      alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-warning":true, "alert-danger": false};  // alert-danger 紅色背景 alert-waring 黃色背景
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
      }
    },
    methods: {

      setMsg: function (message, timer) {
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
        }, timer*1000);
      },
      setMsg1: function (message, timer) {  // show message for timer sec and logout
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            ////// to complete logout and show login page need this 3 items
            //this.$store.dispatch("setUser", {name: '', token: ''});
            //this.$auth.destroyToken();
            this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
        }, timer*1000);
    },    
      register: function() {
        // this.$router.push('/home/' + this.$auth.getLang());
        console.log("register: ", this.user.username);
        //console.log("register: ", this.user);
        let router = this.$router;
        ////////// check e-mail format //////////
        //var emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //if (Vue.email_new!=='' && !Vue.email_new.match(emailValidator)) {Vue.email_new=Vue.email; // check email format
        if (this.user.email!=='' && !this.user.email.includes('@')) {this.user.email='';}; // check email format, if no @ then ""
        if (this.user.username.indexOf(" ") == -1 && this.user.password.indexOf(" ") == -1 && this.user.email.indexOf(" ") == -1) {   // check for space in username password email string
          if (this.user.password === this.user.confirm) {
            this.$http.post(PURL + "/api/v1/KH/register-account", this.user)
            .then(function(res) {
              //console.log("res: ", res);
              console.log("Success! You can now login with your email and password");
              this.message=this.msglist[this.$route.params.language][4];
              this.setMsg1(this.message + this.user.username, 5);
              //setTimeout(() => {
              //  this.$router.push("login");
              //}, 5000);
            }, reason => {
              let rea=JSON.stringify(reason) ; 
                console.log('server error: ', reason.body);
                //Vue.message = 'error: server error when fetching: ';
                if (rea.match(/serial and passcode does not match/gi)) {
                    this.message=this.msglist[this.$route.params.language][0];
                } else if (rea.match(/username duplicated/gi)) {
                    this.message=this.msglist[this.$route.params.language][2];
                } else if (rea.match(/device owned by other user/gi)) {
                    this.message=this.msglist[this.$route.params.language][3];
                } else {
                    this.message=this.msglist[this.$route.params.language][1];
                }
                this.setMsg(this.message, 5);
            }); // reason // then(function(res)
            } else {  // if password=confirm password
            console.log('server error: ', 'Confirm password is different from password');
            this.message=this.msglist[this.$route.params.language][5];
            this.setMsg(this.message, 5);}
          } else {   // if there is a space in username passwoed string
            console.log('server error: ', 'found Space in username password email');
            this.message=this.msglist[this.$route.params.language][6];
            this.setMsg(this.message, 5);}
    
      } // register function
    } // method:
  }  // export default
</script>

<style>

</style>



// WEBPACK FOOTER //
// Register.vue?d2766c16